import io from 'socket.io-client';
import {store} from '../store/store';
import {clearPendingForms} from '../store/reducers/formReducer';
import appConfig from '../config/appConfig';
import {clearPendingPromoterForms} from "../store/reducers/formPromoterReducer";

const socket = io(appConfig.apiHost, {
    path: appConfig.wsPath,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    timeout: 1000
});

let isConnected = false;
let healthTimeout = null;

const sendHealthCheck = () => {
    if (socket.connected) {
        socket.emit('health');
        healthTimeout = setTimeout(() => {
            if (isConnected) {
                console.warn('Responding to health check timeout, marking as disconnected.');
                isConnected = false;
            }
        }, 1000);
    }
};

setInterval(sendHealthCheck, 2000);

socket.on('connect', () => {
    console.info('Connected to ws server.');
    isConnected = true;
    const pendingForms = store.getState().form.pendingForms;
    if (pendingForms.length > 0) {
        socket.emit('batchForms', pendingForms);
        store.dispatch(clearPendingForms());
    }

    const pendingPromoterForms = store.getState().formPromoter.pendingPromoterForms;
    if (pendingPromoterForms.length > 0) {
        socket.emit('batchPromoterForms', pendingPromoterForms);
        store.dispatch(clearPendingPromoterForms());
    }
});

socket.on('healthAck', () => {
    if (healthTimeout) {
        clearTimeout(healthTimeout);
        healthTimeout = null;
    }
    isConnected = true;
});

socket.on('connect_error', (error) => {
    console.error('WS connection error:', error.message);
    isConnected = false;
});

socket.on('disconnect', () => {
    console.warn('Disconnected from server ws.');
});

socket.on('forceDisconnect', () => {
    console.warn('Forced disconnect from server ws.');
    isConnected = false;
});

setInterval(() => {
    if (!socket.connected && isConnected) {
        console.warn('Connection lost, marking as disconnected.');
        isConnected = false;
    }
}, 1000);

export const getConnectionStatus = () => isConnected;

export default socket;